import type { ReactNode } from "react"
import { useCertificateState } from "../context/CertificateState"
import CertificateMediaManager from "./CertificateMediaManager"

type CertificateTemplateReplaceProps = {
  renderButton: (props: { onClick: () => void }) => ReactNode
}

/**
 * Opens the certificate media manager to replace the template.
 * Expects to be rendered within CertificateState.
 */
const CertificateTemplateReplace = ({
  renderButton
}: CertificateTemplateReplaceProps) => {
  const { handleChangeTemplate } = useCertificateState()

  return (
    <CertificateMediaManager
      // NOTE: handleChangeTemplate may return a promise when selecting the
      // template creates the certificate. The MediaManager handles loading.
      onChange={(mediaUrl: string) => handleChangeTemplate(mediaUrl)}
      renderButton={renderButton}
    />
  )
}

CertificateTemplateReplace.displayName = "CertificateTemplateReplace"

export default CertificateTemplateReplace
